import { useEffect, useState } from "react";
import { YazdirDialog } from "@/components/sablon/SablonluBelge";
import { iadeVeri } from "@/lib/belgeVeri";
import { Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { GradButton, fmtMoney } from "@/components/erp";
import api from "@/lib/api";

const S = ({ l, v }) => (v ? <div><span className="text-neutral-500">{l}: </span>{v}</div> : null);
const vd = (x) => [x?.vergi_dairesi, x?.vergi_no].filter(Boolean).join(" / ");

const Belge = ({ f }) => (
  <div className="print-area bg-white text-neutral-900 rounded-xl p-8 text-[13px] leading-relaxed" data-testid="iade-belge">
    <div className="flex justify-between gap-6 border-b border-neutral-300 pb-4">
      <div>{f.firma.logo_url && <img src={f.firma.logo_url} alt="" className="h-10 mb-2" />}
        <div className="font-bold text-base">{f.firma.unvan}</div><div className="text-neutral-600 max-w-xs">{f.firma.adres}</div>
        <S l="Tel" v={f.firma.telefon} /><S l="E-posta" v={f.firma.email} /><S l="V.D. / No" v={vd(f.firma)} /></div>
      <div className="text-right"><div className="text-xl font-bold tracking-wide uppercase">{f.tur_ad}</div>
        <div className="font-mono mt-1">{f.no}</div><div className="whitespace-nowrap">Tarih: {f.tarih}</div>
        {f.kaynak_fatura_no && <div className="whitespace-nowrap">İade edilen fatura: {f.kaynak_fatura_no}</div>}
        {f.durum === "iptal" && <div className="font-bold text-red-600 mt-1">İPTAL</div>}</div>
    </div>
    <div className="py-4 border-b border-neutral-300"><div className="text-[11px] uppercase text-neutral-500 mb-1">{f.tur === "alis_iade" ? "Tedarikçi" : "Müşteri"}</div>
      <div className="font-semibold">{f.cari_unvan}</div>
      <div className="text-neutral-600">{[f.cari.adres, [f.cari.ilce, f.cari.il].filter(Boolean).join(" / ")].filter(Boolean).join(" · ")}</div>
      <S l="V.D. / No" v={vd(f.cari)} /><S l="Tel" v={f.cari.telefon} /></div>
    <table className="w-full mt-4">
      <thead><tr className="text-left text-[11px] uppercase text-neutral-500 border-b border-neutral-300"><th className="py-2">Kod</th><th>Ürün</th><th className="text-right">Miktar</th><th className="text-right">Birim Fiyat</th><th className="text-right">KDV</th><th className="text-right">Tutar</th></tr></thead>
      <tbody>{f.kalemler.map((k, i) => (
        <tr key={i} className="border-b border-neutral-200"><td className="py-2 font-mono text-xs">{k.kod}</td><td>{k.ad}</td><td className="text-right">{k.miktar} {k.birim}</td>
          <td className="text-right">{fmtMoney(k.birim_fiyat)}</td><td className="text-right">%{k.kdv_orani}</td><td className="text-right">{fmtMoney(k.tutar)}</td></tr>))}</tbody>
    </table>
    <div className="ml-auto max-w-xs mt-4 space-y-1">
      <div className="flex justify-between"><span>KDV Hariç</span><span>{fmtMoney(f.ara_toplam)}</span></div>
      <div className="flex justify-between"><span>KDV</span><span>{fmtMoney(f.kdv_toplam)}</span></div>
      <div className="flex justify-between font-bold border-t border-neutral-300 pt-1"><span>Genel Toplam</span><span>{fmtMoney(f.genel_toplam)}</span></div>
    </div>
    {f.aciklama && <div className="mt-6 text-neutral-700"><div className="text-[11px] uppercase text-neutral-500">İade nedeni</div>{f.aciklama}</div>}
    <div className="grid grid-cols-2 gap-6 mt-24 text-center text-neutral-500"><div className="border-t border-neutral-300 pt-2">Teslim eden</div><div className="border-t border-neutral-300 pt-2">Teslim alan (kaşe / imza)</div></div>
  </div>
);

export const IadeYazdir = ({ id, onClose }) => {
  const [f, setF] = useState(null);
  useEffect(() => { api.get(`/iade-faturalari/${id}`).then((r) => setF(r.data)); }, [id]);
  return f ? <YazdirDialog tur="iade_faturasi" d={iadeVeri(f)} baslik={f.tur_ad || "İade Faturası"} onClose={onClose} /> : null;
};

